import {
  GET_COMPANY_INDUSTRY,
  GET_COMPANY_INDUSTRY_SUCCEEDED,
  GET_COMPANY_INDUSTRY_ERROR,
  EDIT_COMPANY,
  EDIT_COMPANY_SUCCEEDED,
  EDIT_COMPANY_ERROR,
  GET_COMPANY_OPTIONS,
  GET_COMPANY_OPTIONS_ERROR,
  GET_COMPANY_OPTIONS_SUCCEEDED,
  EDIT_COMPANY_LOGO,
  EDIT_COMPANY_LOGO_ERROR,
  EDIT_COMPANY_LOGO_SUCCEEDED,
  GET_PROVINCES,
  GET_PROVINCES_ERROR,
  GET_PROVINCES_SUCCEEDED,
  CompanyProfileActions,
  CompanyProfileState,
  InitialState,
  EDIT_COMPANY_LOGO_RESET,
  GET_ENCABEZADO_COMPANY,
  GET_ENCABEZADO_COMPANY_SUCCEEDED,
  GET_ENCABEZADO_COMPANY_ERROR,
  EDIT_ENCABEZADO_COMPANY,
  EDIT_ENCABEZADO_COMPANY_SUCCEEDED,
  EDIT_ENCABEZADO_COMPANY_ERROR,
  GET_BENEFICIOS_COMPANY,
  GET_BENEFICIOS_COMPANY_SUCCEEDED,
  GET_BENEFICIOS_COMPANY_ERROR,
  EDIT_BENEFICIOS_COMPANY,
  EDIT_BENEFICIOS_COMPANY_SUCCEEDED,
  EDIT_BENEFICIOS_COMPANY_ERROR,
} from './types'
import { status } from '../typeStatus'

const CompanyProfileReducer = (
  state: CompanyProfileState = InitialState,
  action: CompanyProfileActions
): CompanyProfileState => {
  switch (action.type) {
    case GET_COMPANY_INDUSTRY:
      return {
        ...state,
        companyIndustry: null,
        statusIndustry: status.loading,
      }
    case GET_COMPANY_INDUSTRY_SUCCEEDED:
      return {
        ...state,
        companyIndustry: action.payload,
        statusIndustry: status.success,
      }
    case GET_COMPANY_INDUSTRY_ERROR:
      return {
        ...state,
        companyIndustry: null,
        statusIndustry: status.error,
      }
    case EDIT_COMPANY: {
      return {
        ...state,
        editCompany: status.loading,
      }
    }
    case EDIT_COMPANY_SUCCEEDED: {
      return {
        ...state,
        editCompany: status.success,
      }
    }
    case EDIT_COMPANY_ERROR: {
      return {
        ...state,
        editCompany: status.error,
      }
    }
    case GET_COMPANY_OPTIONS: {
      return {
        ...state,
        companyOptions: null,
        statusCompanyOptions: status.loading,
      }
    }
    case GET_COMPANY_OPTIONS_SUCCEEDED: {
      return {
        ...state,
        companyOptions: action.payload,
        statusCompanyOptions: status.success,
      }
    }
    case GET_COMPANY_OPTIONS_ERROR: {
      return {
        ...state,
        companyOptions: null,
        statusCompanyOptions: status.error,
      }
    }
    case GET_COMPANY_OPTIONS_ERROR: {
      return {
        ...state,
        companyOptions: null,
        statusCompanyOptions: status.initial,
      }
    }
    case EDIT_COMPANY_LOGO: {
      return {
        ...state,
        editCompanyLogo: status.loading,
      }
    }

    case EDIT_COMPANY_LOGO_RESET: {
      return {
        ...state,
        editCompanyLogo: status.initial,
      }
    }

    case EDIT_COMPANY_LOGO_SUCCEEDED: {
      return {
        ...state,
        editCompanyLogo: status.success,
      }
    }

    case EDIT_COMPANY_LOGO_ERROR: {
      return {
        ...state,
        editCompanyLogo: status.error,
      }
    }
    case GET_PROVINCES: {
      return {
        ...state,
        provinces: null,
        statusProvinces: status.loading,
      }
    }
    case GET_PROVINCES_SUCCEEDED: {
      return {
        ...state,
        provinces: action.payload,
        statusProvinces: status.success,
      }
    }
    case GET_PROVINCES_ERROR: {
      return {
        ...state,
        provinces: null,
        statusProvinces: status.error,
      }
    }

    case GET_ENCABEZADO_COMPANY: {
      return {
        ...state,
        encabezado: null,
        statusEncabezado: status.loading,
      }
    }
    case GET_ENCABEZADO_COMPANY_SUCCEEDED: {
      return {
        ...state,
        encabezado: action.payload,
        statusEncabezado: status.success,
      }
    }
    case GET_ENCABEZADO_COMPANY_ERROR: {
      return {
        ...state,
        encabezado: null,
        statusEncabezado: status.error,
      }
    }

    case EDIT_ENCABEZADO_COMPANY: {
      return {
        ...state,
        encabezado: null,
        statusEditEncabezado: status.loading,
      }
    }
    case EDIT_ENCABEZADO_COMPANY_SUCCEEDED: {
      return {
        ...state,
        encabezado: action.payload,
        statusEditEncabezado: status.success,
      }
    }
    case EDIT_ENCABEZADO_COMPANY_ERROR: {
      return {
        ...state,
        encabezado: null,
        statusEditEncabezado: status.error,
      }
    }

    case GET_BENEFICIOS_COMPANY: {
      return {
        ...state,
        beneficios: null,
        statusBeneficios: status.loading,
      }
    }
    case GET_BENEFICIOS_COMPANY_SUCCEEDED: {
      return {
        ...state,
        beneficios: action.payload,
        statusBeneficios: status.success,
      }
    }
    case GET_BENEFICIOS_COMPANY_ERROR: {
      return {
        ...state,
        beneficios: null,
        statusBeneficios: status.error,
      }
    }

    case EDIT_BENEFICIOS_COMPANY: {
      return {
        ...state,
        beneficios: null,
        statusEditBeneficios: status.loading,
      }
    }
    case EDIT_BENEFICIOS_COMPANY_SUCCEEDED: {
      return {
        ...state,
        beneficios: action.payload,
        statusEditBeneficios: status.success,
      }
    }
    case EDIT_BENEFICIOS_COMPANY_ERROR: {
      return {
        ...state,
        beneficios: null,
        statusEditBeneficios: status.error,
      }
    }

    default:
      return state
  }
}

export default CompanyProfileReducer
